import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Shows a retry countdown; a custom key must include the {{time}} placeholder.
 *
 * `tone` הוא **מה שקרה**, ולא איך זה נראה.
 *
 * ברוב המסכים הספירה באה אחרי סירוב - תקרה שנגמרה, קוד שגוי - וההודעה אדומה בצדק.
 * אבל ספירת הצינון שרצה אחרי שליחה **שהצליחה** אינה סירוב: היא אומרת מתי אפשר לבקש
 * שוב, והיא מוצגת ברגע שבו הכול עבד. אדום שם מדווח על תקלה שאין, ושולח את הלקוח
 * לחפש מה השתבש.
 *
 * ברירת המחדל היא `error` - כלומר אף אחד משמונת המסכים הקוראים אינו משתנה.
 */
const RetryNotice = ({ retry, i18nKey = "Please try again in {{time}}", tone = "error" }) => {
  const { t } = useTranslation();

  if (!retry.isWaiting) {
    return null;
  }

  return (
    <h2 className={tone === "info" ? "mt20 retry-notice-info" : "mt20 error"}>
      {t(i18nKey, { time: retry.label })}
    </h2>
  );
};

export default RetryNotice;
